import getAnalyticsApi from '@custom/rtk-apis/billing/analytics/getAnalytics';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: ''
};

const getAnalyticsSlice = createSlice({
  name: 'getAnalyticsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnalyticsApi.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getAnalyticsApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.data;
        state.result = payload.data;
        state.msg = payload.message || 'Success';
      })
      .addCase(getAnalyticsApi.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string || 'Failed to fetch analytics';
        state.result = null;
      });
  },
});

export default getAnalyticsSlice.reducer;
